<template>
  <div class="relative">
    <input
      v-model="inputValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :class="[
        'border border-gray-300 w-full px-3 py-2 text-text1 focus:outline-none bg-transparent',
        // noBorder
        //   ? 'border-0 border-b-2 border-gray2 rounded-none hover:border-primary focus:border-primary transition-colors'
        //   : 'border border-gray-300 focus:ring-2 focus:ring-primary',
        disabled ? 'cursor-not-allowed opacity-60' : ''
      ]"
      @input="handleInput"
      @focus="!disabled && (showDropdown = true)"
      @blur="handleBlur"
      @keydown.enter="handleEnter"
    />
    <ul v-if="showDropdown && !disabled" class="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-xl max-h-60 overflow-y-auto shadow-lg">
      <li
        v-for="option in timeOptions"
        :key="option.value"
        @mousedown.prevent="selectTime(option.value)"
        class="px-3 py-2 hover:bg-gray-200 cursor-pointer"
      >
        {{ option.display }} {{ option.duration ? `(${option.duration})` : '' }}
      </li>
    </ul>
  </div>
</template>

<script>
// import moment from 'moment'

export default {
  name: 'CustomTimePicker',
  props: {
    value: {
      type: String,
      default: ''
    },
    timeOptions: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Select or enter time'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    noBorder: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputValue: '',
      showDropdown: false
    }
  },
  mounted() {
    this.inputValue = this.formatInputDisplay(this.value);
  },
  watch: {
    value(newValue) {
      this.inputValue = this.formatInputDisplay(newValue);
    }
  },
  methods: {
    formatInputDisplay(time) {
      if (!time) return '';
      const [hours, minutes] = time.split(':').map(Number);
      const period = hours >= 12 ? 'PM' : 'AM';
      const displayHour = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
      return `${displayHour}:${minutes.toString().padStart(2, '0')} ${period}`;
    },
    parseInput(input) {
      if (!input) return '';
      // Handle inputs like "1:30 PM", "13:30", "1:30pm", etc.
      const cleanInput = input.trim().toLowerCase();
      const regex = /^(\d{1,2}):(\d{2})\s*(am|pm)?$/i;
      const match = cleanInput.match(regex);
      
      if (!match) return this.value; // Return original value if invalid

      let [ hours, minutes, period] = match;
      hours = parseInt(hours);
      minutes = parseInt(minutes);

      if (period) {
        if (period.toLowerCase() === 'pm' && hours < 12) {
          hours += 12;
        } else if (period.toLowerCase() === 'am' && hours === 12) {
          hours = 0;
        }
      }

      if (hours > 23 || minutes > 59) return this.value;

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    },
    handleInput(event) {
      if (this.disabled) return;
      this.inputValue = event.target.value;
    },
    handleEnter() {
      if (this.disabled) return;
      const parsedTime = this.parseInput(this.inputValue);
      this.inputValue = this.formatInputDisplay(parsedTime);
      this.$emit('input', parsedTime);
      this.showDropdown = false;
    },
    handleBlur() {
      if (this.disabled) return;
      setTimeout(() => {
        if (this.inputValue !== this.formatInputDisplay(this.value)) {
          const parsedTime = this.parseInput(this.inputValue);
          this.inputValue = this.formatInputDisplay(parsedTime);
          this.$emit('input', parsedTime);
        }
        this.showDropdown = false;
      }, 200);
    },
    selectTime(time) {
      if (this.disabled) return;
      this.inputValue = this.formatInputDisplay(time);
      this.$emit('input', time);
      this.showDropdown = false;
    }
  }
}
</script>

<style scoped>
.custom-time-picker {
  @apply relative;
}
.custom-time-picker input {
  @apply w-full px-3 py-2 rounded-xl text-text1 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary;
}
.custom-time-picker ul {
  @apply bg-white border border-gray-300 rounded-xl max-h-60 overflow-y-auto shadow-lg;
}
.custom-time-picker li {
  @apply px-3 py-2 hover:bg-gray-100 cursor-pointer text-text1;
}

/* .custom-time-picker ul {
  white-space: nowrap;
  width: auto !important;      
  min-width: 150px;            
  max-width: 400px;            
  overflow-x: visible !important;
} */

.custom-time-picker ul {
  @apply bg-white border border-gray-300 rounded-xl max-h-60 overflow-y-auto shadow-lg;
  width: 100%; /* Match input width */
}

.custom-time-picker li {
  white-space: nowrap;       
  text-overflow: ellipsis;   
  overflow: hidden;
  padding: 8px 12px;
  cursor: pointer;
}
</style>